import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes } from '@angular/router';
import { MaterialModule } from '../../../../../core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import {DepartmentRoutingModule} from './department-routing.module';
import { DepartmentComponent } from './components/department.component';
import { MatTableModule } from '@angular/material';
import {NgZorroAntdModule} from "ng-zorro-antd";

import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { AddDepartmentComponent } from './components/add-department/add-department.component';
import { SearchInputModule } from '../../../../../shared/components/search-input/search-input.module';
import { UpdateDepartmentComponent } from './components/update-department/update-department.component';
import { AssignRepresentativeComponent } from './components/assign-representative/assign-representative.component';
import { AddUserDepartmentComponent } from './components/add-user-department/add-user-department.component';
import { DepartmentDetailComponent } from './components/department-detail/department-detail.component';

@NgModule({
  declarations: [DepartmentComponent, AddDepartmentComponent, UpdateDepartmentComponent, AssignRepresentativeComponent, AddUserDepartmentComponent, DepartmentDetailComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    DepartmentRoutingModule,
    MatTableModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    NgMatAutocompleteModule,
    NgZorroAntdModule,
    SearchInputModule
  ],
  exports: [
    TranslateModule,
    DepartmentComponent
  ],
  entryComponents: [
    DepartmentComponent,
    AddDepartmentComponent,
    UpdateDepartmentComponent,
    AssignRepresentativeComponent,
    AddUserDepartmentComponent,
    DepartmentDetailComponent
  ]
})
export class DepartmentModule { }
